import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import { AxlPanel } from 'axl-reactjs-ui';

// styles
import styles, * as E from '../../styles';

export default class SingleOrderReview extends React.Component {
  render() {
    const { goStep, getFormValue, shipmentTags, shipment, parcels, userStore } = this.props;
    const { clientProfileOptions } = userStore;
    const serviceLevelMaps = {
      NEXT_DAY: `Next-Day Shipping`,
      SAME_DAY: `Same-Day Shipping`,
      ASAP: `ASAP Shipping`
    };
    const filteredParcels = parcels.filter(parcel => !!parcel.type);
    const fromTS = getFormValue('dropoff_earliest_time') !== '' && moment(getFormValue('dropoff_earliest_time')).format('hh:mmA') || '';
    const toTS = getFormValue('dropoff_latest_time') !== '' && moment(getFormValue('dropoff_latest_time')).format('hh:mmA') || '';
    const deliveryWindows = [fromTS, toTS];
    const shipmentValue = getFormValue("value");
    const clientProfileId = getFormValue("client_profile_id");
    const clientProfile = clientProfileOptions.find(cp => cp.value === clientProfileId);

    return (
      <E.StepContainer>
        <E.Panel>
          <E.PanelTitle>{`Customer Information`}<E.ButtonEdit onClick={() => goStep(1)}>{`Edit`}</E.ButtonEdit></E.PanelTitle>
          <E.PanelContent>
            <AxlPanel>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Full name`}</E.Label>
                  <E.Text>{getFormValue("customer.name")}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Email address`}</E.Label>
                  <E.Text>{getFormValue("customer.email")}</E.Text>
                </AxlPanel.Col>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Phone no.`}</E.Label>
                  <E.Text>{getFormValue("customer.phone_number")}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
            </AxlPanel>
          </E.PanelContent>
        </E.Panel>
        <E.Panel>
          <E.PanelTitle>{`Order Information`}<E.ButtonEdit onClick={() => goStep(1)}>{`Edit`}</E.ButtonEdit></E.PanelTitle>
          <E.PanelContent>
            <AxlPanel>
              {clientProfile && (
                <AxlPanel.Row style={styles.row}>
                  <AxlPanel.Col style={styles.col}>
                    <E.Label>{`Brand name`}</E.Label>
                    <E.Text>{clientProfile.label}</E.Text>
                  </AxlPanel.Col>
                </AxlPanel.Row>
              )}
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Internal ID`}</E.Label>
                  <E.Text>{getFormValue("internal_id")}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Order Description`}</E.Label>
                  <E.Text>{_.defaultTo(getFormValue("order_detail"), 'N/A')}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Value`}</E.Label>
                  <E.Text>{shipmentValue ? `${parseFloat(shipmentValue).toFixed(2)}` : '-'}</E.Text>
                </AxlPanel.Col>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Currency`}</E.Label>
                  <E.Text>{_.defaultTo(getFormValue("currency"), '')}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Tags`}</E.Label>
                  <E.CheckboxGroup>
                  {shipmentTags && shipmentTags.map((tag, index) =>
                    <E.CheckboxItem key={index}>
                      <E.Text>{(shipment.tags && (Object.values(shipment.tags).indexOf(tag) !== -1) ? <E.I1 className="fa fa-check" /> : <E.I2 className="fa fa-times" />)} {tag.toUpperCase()}</E.Text>
                    </E.CheckboxItem>)}
                </E.CheckboxGroup>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row>
                <AxlPanel.Col style={styles.col}>
                  {filteredParcels && _.isArray(filteredParcels) && filteredParcels.map((parcel, index) => {
                    const dimensionUnit = parcel.dimensions.unit || 'in';
                    const weightUnit = parcel.weight.unit || 'lb';
                    const type = !parcel.predefined ? _.capitalize(parcel.type) : parcel.label;
                    const isParcelOptionAvailable = !parcel.predefined && parcel.type !== 'bag';
                    const pLength = parcel.dimensions.length || '-';
                    const pWidth = parcel.dimensions.width || '-';
                    const pHeight = parcel.dimensions.height || '-';
                    const pWeight = parcel.weight.value || '-';

                    return (
                      <div key={index}>
                        <E.Label>{`Parcel ${index + 1}`}</E.Label>
                        <E.InputGroupContainer>
                          <E.Row>
                            <E.Col>
                              <E.Label>{`Parcel Type`}</E.Label>
                              <E.Text>{type || '-'}</E.Text>
                            </E.Col>
                            <E.Col>
                              <E.Label>{`Parcel ID`}</E.Label>
                              <E.Text>{parcel.parcel_id || '-'}</E.Text>
                            </E.Col>
                          </E.Row>
                          {isParcelOptionAvailable && (
                            <E.Row>
                              <E.Col>
                                <E.Label>{`Parcel dimension`}</E.Label>
                                <E.Text>{`${pLength} ${dimensionUnit} x ${pWidth} ${dimensionUnit} x ${pHeight} ${dimensionUnit}`}</E.Text>
                              </E.Col>
                              <E.Col>
                                <E.Label>{`Parcel weight`}</E.Label>
                                <E.Text>{`${pWeight} ${weightUnit}`}</E.Text>
                              </E.Col>
                            </E.Row>
                          )}
                        </E.InputGroupContainer>
                      </div>
                    )
                  })}
                </AxlPanel.Col>
              </AxlPanel.Row>
            </AxlPanel>
          </E.PanelContent>
        </E.Panel>
        <E.Panel>
          <E.PanelTitle>{`Pick-Up Information`}<E.ButtonEdit onClick={() => goStep(2)}>{`Edit`}</E.ButtonEdit></E.PanelTitle>
          <E.PanelContent>
            <AxlPanel>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Pick-Up Address`}</E.Label>
                  <E.Text>{getFormValue("pickup_address.street2")}</E.Text>
                  <E.Text>{`${getFormValue("pickup_address.street")}, ${getFormValue("pickup_address.city")}, ${getFormValue("pickup_address.state")} ${getFormValue("pickup_address.zipcode")}`}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Pick-Up Note`}</E.Label>
                  <E.Text>{getFormValue("pickup_note")}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
            </AxlPanel>
          </E.PanelContent>
        </E.Panel>
        <E.Panel>
          <E.PanelTitle>{`Drop-Off Information`}<E.ButtonEdit onClick={() => goStep(3)}>{`Edit`}</E.ButtonEdit></E.PanelTitle>
          <E.PanelContent>
            <AxlPanel>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Drop-Off Address`}</E.Label>
                  <E.Text>{getFormValue("dropoff_address.street")}</E.Text>
                  <E.Text>{getFormValue("dropoff_address.street2")}</E.Text>
                  <E.Text>{`${getFormValue("dropoff_address.city")}, ${getFormValue("dropoff_address.state")} ${getFormValue("dropoff_address.zipcode")}`}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Latitude`}</E.Label>
                  <E.Text>{getFormValue("dropoff_address.latitude")}</E.Text>
                </AxlPanel.Col>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Longitude`}</E.Label>
                  <E.Text>{getFormValue("dropoff_address.longitude")}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Drop-Off Note`}</E.Label>
                  <E.Text>{getFormValue("dropoff_note")}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
            </AxlPanel>
          </E.PanelContent>
        </E.Panel>
        <E.Panel>
          <E.PanelTitle>{`Service/Shipping Information`}<E.ButtonEdit onClick={() => goStep(4)}>{`Edit`}</E.ButtonEdit></E.PanelTitle>
          <E.PanelContent>
            <AxlPanel>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Service Type`}</E.Label>
                  <E.Text>{serviceLevelMaps[getFormValue("service_level")]}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Pick-up Date`}</E.Label>
                  <E.Text>{moment(getFormValue("pickup_date_ts")).format('MM/DD/YYYY')}</E.Text>
                </AxlPanel.Col>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Delivery Date`}</E.Label>
                  <E.Text>{moment(getFormValue("dropoff_date_ts")).format('MM/DD/YYYY')}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Earliest Pick-Up Time`}</E.Label>
                  <E.Text>
                    {getFormValue("pickup_earliest_time")
                      ? moment(getFormValue("pickup_earliest_time")).format('HH:mm A')
                      : '-'
                    }
                  </E.Text>
                </AxlPanel.Col>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Latest Pick-Up Time`}</E.Label>
                  <E.Text>
                    {getFormValue("pickup_latest_time")
                      ? moment(getFormValue("pickup_latest_time")).format('HH:mm A')
                      : '-'
                    }
                  </E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Delivery Window`}</E.Label>
                  <E.Text>{deliveryWindows && deliveryWindows.length > 0 && deliveryWindows.join(' - ') || ''}</E.Text>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Required Service`}</E.Label>
                  <AxlPanel.Row style={styles.row}>
                    <AxlPanel.Col style={styles.col}>
                      <E.Text>{getFormValue("delivery_proof_photo_required") ? <E.I1 className="fa fa-check" /> : <E.I2 className="fa fa-times" />} {`Photo POD`}</E.Text>
                    </AxlPanel.Col>
                    <AxlPanel.Col style={styles.col}>
                      <E.Text>{getFormValue("signature_required") ? <E.I1 className="fa fa-check" /> : <E.I2 className="fa fa-times" />} {`Signature`}</E.Text>
                    </AxlPanel.Col>
                    <AxlPanel.Col style={styles.col}>
                      <E.Text>{getFormValue("id_required") ? <E.I1 className="fa fa-check" /> : <E.I2 className="fa fa-times" />} {`ID Check`}</E.Text>
                    </AxlPanel.Col>
                    <AxlPanel.Col style={styles.col}>
                      <E.Text>{getFormValue("sms_enabled") ? <E.I1 className="fa fa-check" /> : <E.I2 className="fa fa-times" />} {`SMS Enable`}</E.Text>
                    </AxlPanel.Col>
                  </AxlPanel.Row>
                </AxlPanel.Col>
              </AxlPanel.Row>
            </AxlPanel>
          </E.PanelContent>
        </E.Panel>
      </E.StepContainer>
    );
  }
}
